<script>
    export default {
        name: "HomeAboutMedia",
    };
</script>

<template>
    <div class="home-about-media">
        <div class="home-about-media__inner">
            <video
                class="home-about-media__video"
                loop=""
                autoplay=""
                muted=""
                playsinline=""
                preload="metadata"
            >
                <source src="/static/finamill/assets/home/about/video.mp4" type="video/mp4" />
            </video>
        </div>
    </div>
</template>

<style lang="scss">
    .home-about-media {
        padding: 12px;
        @include bp($bp-desktop-sm) {
            flex-basis: 50%;
            max-width: 50%;
            padding: 0;
        }
    }

    .home-about-media__inner {
        position: relative;
        height: 100%;
        padding-bottom: 56.25%;
    }

    .home-about-media__video {
        @include center-absolute(0);
        display: block;
        max-width: 100%;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
</style>
